import { render } from "./LogOutPage.vue?vue&type=template&id=d5aa6588&ts=true"
import script from "./LogOutPage.vue?vue&type=script&lang=ts"
export * from "./LogOutPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Authentication/LogOutPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d5aa6588"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d5aa6588', __exports__)) {
    api.reload('d5aa6588', __exports__)
  }
  
  module.hot.accept("./LogOutPage.vue?vue&type=template&id=d5aa6588&ts=true", () => {
    api.rerender('d5aa6588', render)
  })

}


export default __exports__